export default __webpack_public_path__ + "static/media/icon_white_shield.57dd9f55.svg";